module.exports = __webpack_public_path__ + "static/avatar-caf53821389f4febe91537e6d1b20c47.png";